import React, { useEffect, useRef, useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { getScreenName } from '../../../Utils/helper';
import SwipeWidget from './SwipeWidget';
import {
  ActionButton,
  AfterImageContainer,
  BeforAfterMain,
  BeforeImageContainer,
  ComparisionDesc,
  ComparisionTitle,
  ResizeButtons,
  ToolTip,
} from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

const BeforeAfter = (props) => {
  const { beforeAfterData } = props;
  const [bgImageWidth, setBgImageWidth] = useState(0);
  const [showWidget, setShowWidget] = useState(true);
  const [inputVal, setInputVal] = useState(beforeAfterData?.defaultValue);
  const rangeRef = useRef();
  const afterImage = useRef();
  const MainContainer = useRef();
  const inputRange = useRef();
  const timeOutRef = useRef();
  const handleInputChange = (e) => {
    const v = e.target.value;

    if (Math.abs(v - inputVal) < 10) {
      afterImage.current.classList.add('noTransition');
      rangeRef.current.classList.add('noTransition');
    } else {
      afterImage.current.classList.remove('noTransition');
      rangeRef.current.classList.remove('noTransition');
    }
    afterImage.current.style.width = `${v}%`;
    rangeRef.current.style.left = `calc(${v}% - 20px)`;
    if (showWidget) {
      setShowWidget(false);
    }
    clearTimeout(timeOutRef.current);
    setInputVal(v);
    timeOutRef.current = setTimeout(() => {
      fireEvent({
        category: 'clicked_sliding_window',
        screen_name: getScreenName(),
        section_name: 'clinical results',
        section_id: '',
        deeplink_value: null,
        shape: '',
        card_ids: '',
        send_to: '',
        finalPos: v,
      });
    }, 1000);
  };
  useEffect(() => {
    const containerWidth = MainContainer?.current?.clientWidth;
    setBgImageWidth(containerWidth);
  }, []);
  return (
    <>
      <ComparisionTitle>{beforeAfterData?.heading}</ComparisionTitle>
      <ComparisionDesc>{beforeAfterData?.description}</ComparisionDesc>
      <BeforAfterMain ref={MainContainer}>
        <AfterImageContainer
          bgImage={beforeAfterData?.afterImage}
          bgImageWidth={bgImageWidth}
        >
          <ActionButton right="0">After</ActionButton>
        </AfterImageContainer>
        <BeforeImageContainer
          bgImage={beforeAfterData?.beforeImage}
          ref={afterImage}
          bgImageWidth={bgImageWidth}
          defaultWidth={beforeAfterData?.defaultValue}
        >
          <ActionButton left="0">Before</ActionButton>
        </BeforeImageContainer>

        <input
          type="range"
          value={inputVal}
          onChange={(e) => {
            handleInputChange(e);
          }}
          ref={inputRange}
        ></input>
        <ResizeButtons
          ref={rangeRef}
          defaultWidth={beforeAfterData?.defaultValue}
        >
          <img
            src={images.ImageSlider}
            alt=""
            draggable="false"
            className="sliderImage"
          />
        </ResizeButtons>
        {showWidget && (
          <>
            <ToolTip defaultWidth={beforeAfterData?.defaultValue}>
              <p>Move the Slider to reveal results</p>
            </ToolTip>
            <SwipeWidget leftOffset={beforeAfterData?.defaultValue} />
          </>
        )}
      </BeforAfterMain>

      <ComparisionDesc>{beforeAfterData?.footer}</ComparisionDesc>
    </>
  );
};

export default BeforeAfter;
